import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircleIcon, ArrowLeftIcon } from 'lucide-react';
import Button from './Button';
const ThankYou = () => {
  return <section className="py-20 bg-white" data-id="element-2269">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 text-center" data-id="element-2270">
        <div className="bg-primary/10 rounded-full w-20 h-20 flex items-center justify-center mx-auto mb-6" data-id="element-2271">
          <CheckCircleIcon className="h-10 w-10 text-primary" data-id="element-2272" />
        </div>
        <h1 className="text-4xl font-bold mb-4" data-id="element-2273">Thank You!</h1>
        <p className="text-xl text-gray-600 mb-8" data-id="element-2274">
          Your submission has been received. Our team will get back to you
          shortly with more information about our AI shopping advisor solutions.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-2275">
          <Link to="/" data-id="element-2276">
            <Button variant="outline" size="lg" data-id="element-2277">
              <ArrowLeftIcon className="mr-2 h-4 w-4" data-id="element-2278" />
              Return to Home
            </Button>
          </Link>
          <Link to="/gpt-store" data-id="element-2279">
            <Button variant="primary" size="lg" data-id="element-2280">
              Learn More About GPT Stores
            </Button>
          </Link>
        </div>
      </div>
    </section>;
};
export default ThankYou;